// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__cqy0Z","options":"AnswerScale_options__2SI7q","selected":"AnswerScale_selected__2Qce8"};